/* eslint-disable */
import { endpoints } from '@/Constants';
import { authHeader } from '@/Helpers';
import handleResponse from './helpers';

const aiPackaging = {
	getData,
	aiPacakgingExport,
	aiPackagingGetDataWithHeaders,
	fetchFmsAnalyticsGrid,
	aiPackagingGetDataWithHeaders,
	fetchFmsAnalyticsGrid,
	fetchWastageSummary,
	fetchBatchList,
};

function fetchBatchList(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
			clientId: 5,
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.BATCH_LIST, requestOptions).then(handleResponse);
}

function getData(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.AI_PACKGING, requestOptions).then(handleResponse);
}

function aiPackagingGetDataWithHeaders(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.AI_PACKGING_GET_DATA_WITH_HEADERS, requestOptions).then(handleResponse);
}

function aiPacakgingExport(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.AI_PACKGING_Export, requestOptions);
}

function fetchFmsAnalyticsGrid(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.FMS_ANALYTICS_GRID, requestOptions).then(handleResponse);
}

function fetchWastageSummary(req = {}) {
	const requestOptions = {
		method: 'POST',
		headers: {
			...authHeader(),
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			...req?.data,
		}),
	};
	return fetch(endpoints?.AI_FMS_WASTAGE_SUMMARY, requestOptions).then(handleResponse);
}

export default aiPackaging;

